import { UPDATE_LIST_NAME_ENDPOINT } from 'api/ListsApi';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';
import { useToastNotification } from 'utils/hooks/useToastNotification';
import { useTranslation } from './useTranslation';
import { UpdateListNameParams, UpdateListNameSuccessResponse } from '../types';
import { useListDetailsContext } from '../contexts/listDetails';

export const useUpdateListNameMutation = (emailListId?: number) => {
  const { t } = useTranslation();
  const { refetch } = useListDetailsContext();

  const { mutate, data, isSuccess, isLoading, isError } = useRestMutation<
    UpdateListNameSuccessResponse,
    UpdateListNameParams
  >(UPDATE_LIST_NAME_ENDPOINT);

  const updateListName = (name: string) => {
    if (emailListId) {
      return mutate({ emailListId, name }, { onSuccess: () => refetch() });
    }
  };

  useToastNotification({
    enabled: !isLoading && !!data,
    positive: isSuccess,
    positiveMessage: data,
  });

  useToastNotification({
    enabled: !isLoading && isError,
    negative: isError,
    negativeMessage: t('toast.listName.negative', { emailListId }),
  });

  return { updateListName };
};
